"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Role;
(function (Role) {
    Role[Role["owner"] = 0] = "owner";
    Role[Role["group"] = 1] = "group";
    Role[Role["others"] = 2] = "others";
})(Role || (Role = {}));
exports.Role = Role;
var Permission;
(function (Permission) {
    Permission[Permission["read"] = 0] = "read";
    Permission[Permission["write"] = 1] = "write";
    Permission[Permission["execute"] = 2] = "execute";
})(Permission || (Permission = {}));
exports.Permission = Permission;
const codeToPermission = (code) => {
    switch (code) {
        case 7:
            return Permissions.rwx;
        case 6:
            return Permissions.rw_;
        case 5:
            return Permissions.r_x;
        case 4:
            return Permissions.r__;
        case 1:
            return Permissions.__x;
        default:
            return Permissions.none;
    }
};
const Permissions = {
    __x: [Permission.execute],
    none: [],
    r__: [Permission.read],
    r_x: [Permission.read, Permission.execute],
    rw_: [Permission.read, Permission.write],
    rwx: [Permission.read, Permission.write, Permission.execute],
    from: (code, role) => {
        return codeToPermission(Math.floor((() => {
            switch (role) {
                case Role.owner:
                    return code / 100;
                case Role.group:
                    return (code % 100) / 10;
                case Role.others:
                    return code % 10;
                default:
                    return 0;
            }
        })()));
    },
};
exports.Permissions = Permissions;
//# sourceMappingURL=index.js.map